import React from "react";
import CurrencyFormat from '../../Formatters/CurrencyFormat';

export default function BudgetAmounts() {

  var start = 15;
  const end = 100;
  const increment = 1;
  var amounts = [];

  for (var i = start; i <= end; i += increment ) {
    amounts.push({label: <CurrencyFormat number={i} whole/>, value: i});
  }

  return amounts;
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/BudgetAmounts/BudgetAmounts.js